export default __webpack_public_path__ + "static/media/stocq-logo.b7fcab79.svg";